import { useLoaderData } from "@tanstack/react-router";
import { seoMeta } from "@/lib/ui/seo";
import { EmailPreferencesSurface } from "./email-preferences-surface";
import { getCommunicationPreferences } from "./profile-settings";

export const emailPreferencesRouteOptions = {
    ssr: false,
    loader: async () => await getCommunicationPreferences(),
    head: () => ({
        ...seoMeta({
            title: "Email Preferences — Wags",
            description: "Manage which Wags emails you receive.",
            url: "/settings/email",
        }),
    }),
};

export function EmailPreferencesRoute() {
    const { allowMarketingEmails, canUpdate } = useLoaderData({
        from: "/settings/email",
    });
    return (
        <EmailPreferencesSurface
            initialMarketingEmails={allowMarketingEmails}
            canUpdate={canUpdate}
            showHeader
        />
    );
}
